import { useState } from "react";
import AnimatedSection from "../common/AnimatedSection";
import SectionTitle from "../common/SectionTitle";
import api from "../../api/axios";

const Contact = () => {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });

    // clear field error while typing
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // 🔥 VALIDATION FUNCTION
  const validate = () => {
    const newErrors = {};

    // Name validation
    if (!form.full_name.trim()) {
      newErrors.full_name = "Name is required";
    } else if (form.full_name.trim().length < 3) {
      newErrors.full_name = "Name must be at least 3 characters";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = "Enter a valid email address";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    const validationErrors = validate();

    // ❌ stop if errors exist
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setError(null);
    setSubmitted(false);

    try {
      const res = await api.post("/contact/submit", form);

      console.log("API RESPONSE:", res.data);

      if (res.status === 200 && res.data?.status === true) {
        setSubmitted(true);
        setForm({ full_name: "", email: "", message: "" });

        setTimeout(() => setSubmitted(false), 3000);
      } else {
        setError(res.data?.message || "Failed to send message");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-24 md:py-32 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16">

          {/* LEFT SIDE */}
          <AnimatedSection>
            <SectionTitle title="Get in Touch" align="left" />

            <p className="text-dark/50 text-lg leading-relaxed mb-10">
              Ready to advance your career or upskill your team? Reach out to us.
            </p>

            {error && (
              <div className="mb-4 text-red-500 text-sm font-medium">
                {error}
              </div>
            )}

            {submitted && (
              <div className="absolute bottom-4 right-4 p-4 text-white bg-green-600 text-sm font-medium rounded-md">
                Message sent successfully!
              </div>
            )}
          </AnimatedSection>

          {/* FORM */}
          <AnimatedSection delay={0.2}>
            <form onSubmit={handleSubmit} className="space-y-6">

              <input
                type="text"
                name="full_name"
                value={form.full_name}
                onChange={handleChange}
                placeholder="Your name"
                className="w-full px-4 py-3.5 rounded-lg border border-dark/10"
              />

              {errors.full_name && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.full_name}
                </p>
              )}

              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                className="w-full px-4 py-3.5 rounded-lg border border-dark/10"
              />

              {errors.email && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.email}
                </p>
              )}

              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Your message..."
                rows={5}
                className="w-full px-4 py-3.5 rounded-lg border border-dark/10"
              />

              <button
                type="submit"
                disabled={loading}
                className="w-full px-8 py-4 bg-primary text-white font-semibold rounded-lg disabled:opacity-60"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>

            </form>
          </AnimatedSection>

        </div>
      </div>
    </section>
  );
};

export default Contact;